import { ScreenReaderElement } from '@components/screen-reader/screen-reader-element';
import { useProcess } from '@react-query/hooks/query/use-process';
import { format } from '@translation-utils/use-translation';
import { useTranslation } from '@translations';

export const ScreenReaderProcessStatus = () => {
    const { data: process } = useProcess();
    const { pendingProcess } = useTranslation();

    if (!process) {
        return null;
    }

    return <ScreenReaderElement text={format(pendingProcess.ariaLabel.processStatus, process.processStatus)} />;
};
